import React, { useEffect, useState, useRef } from 'react';
import style from './chart.module.scss';
import options from './chartAll.jsx';
import ReactEcharts from 'echarts-for-react';
import NoData from './noData.jsx';
import ChatTitle from '@/modules/pain-points/components/chart-main/chatTitle.jsx';
import Search from './chartSearch.jsx';
import ChartListFilter from './chartRightFilter.jsx';
import ChartList from '@/modules/pain-points/components/chart-main/chartList.jsx';
import ChartDetail from '@/modules/pain-points/components/chart-main/chartDetail.jsx';
import EventBus from '@/modules/pain-points/hooks/eventBus';
import { painPointGetDetail, painPointGetVerbatims } from '@/modules/pain-points/api/request';
import InfoTooltip from './InfoTooltip.jsx';
import exclamation from '@/modules/pain-points/img/exclamation.png';
import { MoreOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';


const dataD = {};


const ChartMain = () => {
  const [dataA, setDataA] = useState([]);
  const [dataB, setDataB] = useState([]);
  const [orderType, setOrderType] = useState(2); // 将 orderType 转换为 state
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const [showTop10Hover, setShowTop10Hover] = useState(false);
  // const [detailData, setDetailData] = useState({});
  const [showAverageDropItems, setShowAverageDropItems] = useState(true);


  useEffect(() => {
    //挂载
    EventBus.addEventListener('painPointListEvent', painPointListEvent);
    EventBus.addEventListener('painPointListChangeEvent', painPointListChangeEvent);
    EventBus.addEventListener('setLoadingEvent', handleLoading);
    EventBus.addEventListener('filterChangeEvent', handleFilterChange);
    return (() => {
      //卸载
      EventBus.removeEventListener('painPointListEvent', painPointListEvent);
      EventBus.removeEventListener('painPointListChangeEvent', painPointListChangeEvent);
      EventBus.removeEventListener('setLoadingEvent', handleLoading);
      EventBus.removeEventListener('filterChangeEvent', handleFilterChange);
    });
  }, [dataA, dataB]);

  let dataARef, dataBRef;
  dataBRef = React.createRef();

  const painPointListEvent = e => {
    setDataA(e.detail);
    dataAToDataB(e.detail, 2);
    EventBus.dispatchEvent('painPointDetailEvent', {});
    console.log('dataA接收到传值啦！~~~~~~');
  };

  const painPointListChangeEvent = e => {
    setOrderType(e.detail);  // 使用 setState 更新 orderType
    dataAToDataB(dataA, e.detail);
    console.log('dataBChange接收到传值啦！~~~~~~');
  };

  const handleFilterChange = (e) => {
    setFilter(e.detail);
    console.log('filterChangeEvent接收到传值啦！~~~~~~', e);
  };

  const dataAToDataB = (data, type = 0) => {
    const dataList = data.map(i => ({ name: i[3], value: i[type], id: i[4] }));
    let a = dataList.sort((a, b) => a.value - b.value)
    setDataB(a);
  };

  const dataASortLimit = (data, type = 0) => {
    // return dataA.sort((a, b) => a[type] - b[type]);
    // todo 正式数据放开这行
    // .slice(0, 10)
    return dataA.sort((a, b) => b[orderType] - a[orderType]).slice(0, 10);
  };

  let detailData = {};

  const queryDetail = async (id, needTitle, filter) => {
    EventBus.dispatchEvent('isDetailLoading', true);
    const result = await painPointGetDetail({ id, needTitle, filter });
    const resultVerbatims = await painPointGetVerbatims({ id, needTitle, filter });
    EventBus.dispatchEvent('painPointDetailEvent', result.data);
    EventBus.dispatchEvent('painPointVerbatimsEvent', resultVerbatims.data);
    console.log('--------详情数据---------', result.data);
    EventBus.dispatchEvent('isDetailLoading', false);
    detailData = result.data;
    // setDetailData(result.data);
    // setShowAverageDropItems(true);
  };

  const chartListRef = useRef(null)

  const dataAOnClick = (param) => {
    // 处理 dataA 的选中效果
    const aInstance = dataARef.getEchartsInstance();
    const aCurrentData = aInstance.getOption().series[0].data;

    // 清除 A 图表所有选中状态
    aCurrentData.forEach((_, idx) => {
      aInstance.dispatchAction({
        type: 'unselect',
        seriesIndex: 0,
        dataIndex: idx
      });
    });

    // 选中当前点击的项
    aInstance.dispatchAction({
      type: 'select',
      seriesIndex: 0,
      dataIndex: param.dataIndex
    });

    // 处理 dataB 的选中效果
    const bInstance = dataBRef.getEchartsInstance();
    const bCurrentData = bInstance.getOption().series[0].data;

    // 清除 B 图表所有选中状态
    bCurrentData.forEach((_, idx) => {
      bInstance.dispatchAction({
        type: 'unselect',
        seriesIndex: 0,
        dataIndex: idx
      });
    });

    // 在 dataB 中查找并选中对应的项
    bCurrentData.forEach((item, idx) => {
      if (item.id === param.data[4]) {  // 使用 id 匹配
        bInstance.dispatchAction({
          type: 'select',
          seriesIndex: 0,
          dataIndex: idx
        });
      }
    });
    
    queryDetail(param.data[4], param.data[3], filter);
    chartListRef.current.scrollIntoView({behavior: 'smooth'})
  };

  const dataBOnClick = (param) => {
    // 处理 dataB 的选中效果
    const bInstance = dataBRef.getEchartsInstance();
    const bCurrentData = bInstance.getOption().series[0].data;

    // 清除 B 图表所有选中状态
    bCurrentData.forEach((_, idx) => {
      bInstance.dispatchAction({
        type: 'unselect',
        seriesIndex: 0,
        dataIndex: idx
      });
    });

    // 选中当前点的项
    bInstance.dispatchAction({
      type: 'select',
      seriesIndex: 0,
      dataIndex: param.dataIndex
    });

    // 处理 dataA 的选中效果
    const aInstance = dataARef.getEchartsInstance();
    const aCurrentData = aInstance.getOption().series[0].data;

    // 清除 A 图表所有选中状态
    aCurrentData.forEach((_, idx) => {
      aInstance.dispatchAction({
        type: 'unselect',
        seriesIndex: 0,
        dataIndex: idx
      });
    });

    // 检查是否在当前显示的数据中
    const checkIndex = dataASortLimit(dataA).findIndex(i => i[4] === param.data.id);

    if (checkIndex === -1) {
      let tempData = dataASortLimit(dataA);
      const newItem = dataA[dataA.findIndex(i => i[4] === param.data.id)];

      if (tempData.length >= 11) {
        // 如果已经有11个数据，替换最后一个
        tempData[10] = newItem;
      } else {
        // 否则直接添加
        tempData.push(newItem);
      }

      aInstance.setOption(options.optionA(tempData));
      // 选中新添加/替换的项
      aInstance.dispatchAction({
        type: 'select',
        seriesIndex: 0,
        dataIndex: tempData.length - 1
      });
    } else {
      // 如果在已显示的数据中，选中对应项
      aInstance.dispatchAction({
        type: 'select',
        seriesIndex: 0,
        dataIndex: checkIndex
      });
    }
    queryDetail(param.data.id, param.data.name, filter);
    // chartListRef.current.scrollIntoView({behavior: 'smooth'})
  };

  const handleSearch = (searchText) => {
    if (!searchText) {
      // 如果搜索框为空，显示原始数据
      dataAToDataB(dataA, orderType);
      return;
    }

    // 过滤匹配的数据
    const filteredData = dataA.filter(item =>
      item[3].toLowerCase().includes(searchText.toLowerCase())
    );

    // 转换过滤后的数据为 dataB 格式
    const searchResults = filteredData.map(i => ({
      name: i[3],
      value: i[orderType],
      id: i[4]
    }));

    // 按当前排序方式排序
    const sortedResults = searchResults.sort((a, b) => a.value - b.value);

    // 更新 dataB
    setDataB(sortedResults);
  };

  const handleLoading = (e) => {
    setIsLoading(e.detail);
    window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
  };

  const dataToFile = async (finalData,fileName,fileType,base64) => {
    if (fileType === 'excel') {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileName);

        // 设置列宽
        worksheet.columns = [
          { header: 'Unmet Need', key: 'unmetNeed', width: 30 },
          { header: 'Reach(%)', key: 'reach', width: 15 },
          { header: 'Importance(%)', key: 'importance', width: 15 },
          { header: 'Willingness To Pay(%)', key: 'willingness', width: 20 }
        ];

        // 添加数据
        finalData.forEach(item => {
          worksheet.addRow({
            unmetNeed: item['Unmet Need'],
            reach: item['Reach(%) '],
            importance: item['Importance(%)'],
            willingness: item['Willingness To Pay(%)']
          });
        });

        // 设置表头样式
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

        if (base64) {
          try {
            // 在数据下方添加一个空行
            worksheet.addRow([]);
            
            // 添加图片标题
            const titleRow = worksheet.addRow(['Chart Image:']);
            titleRow.font = { bold: true };
            
            // 获取图片数据
            const imageId = workbook.addImage({
              base64: base64,
              extension: 'png',
            });

            // 添加图片到工作表
            worksheet.addImage(imageId, {
              tl: { col: 0, row: worksheet.rowCount },
              ext: { width: 600, height: 400 }
            });

            // 调整图片后的行高
            worksheet.getRow(worksheet.rowCount).height = 300;

          } catch (error) {
            console.error('Error adding image:', error);
          }
        }

        // 生成并下载文件
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Error creating Excel file:', error);
      }
    } else if (fileType === 'csv') {
      const ws = XLSX.utils.json_to_sheet(finalData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, fileName);
      XLSX.writeFile(wb, `${fileName}.csv`);
    }
  }

  const averagedataToFile = async (finalData,fileName,fileType,base64) => {
    if (fileType === 'excel') {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(fileName);

        // 设置列宽
        worksheet.columns = [
          { header: 'Category', key: 'category', width: 30 },
          { header: 'SubMetric', key: 'subMetric', width: 15 },
          { header: 'Percent(%)', key: 'percent', width: 15 },
        ];

        // 添加数据
        finalData.forEach(item => {
          worksheet.addRow({
            category: item['Category'],
            subMetric: item['SubMetric'],
            percent: item['Percent(%)']
          });
        });

        // 设置表头样式
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };

        if (base64) {
          try {
            // 在数据下方添加一个空行
            worksheet.addRow([]);
            
            // 添加图片标题
            const titleRow = worksheet.addRow(['Chart Image:']);
            titleRow.font = { bold: true };
            
            // 获取图片数据
            const imageId = workbook.addImage({
              base64: base64,
              extension: 'png',
            });

            // 添加图片到工作表
            worksheet.addImage(imageId, {
              tl: { col: 0, row: worksheet.rowCount },
              ext: { width: 600, height: 400 }
            });

            // 调整图片后的行高
            worksheet.getRow(worksheet.rowCount).height = 300;

          } catch (error) {
            console.error('Error adding image:', error);
          }
        }

        // 生成并下载文件
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Error creating Excel file:', error);
      }
    } else if (fileType === 'csv') {
      const ws = XLSX.utils.json_to_sheet(finalData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, fileName);
      XLSX.writeFile(wb, `${fileName}.csv`);
  }}

  const exportData = (e,fileName,fileType,base64) => {
    const data = []
    // const header = ['Unmet Need', 'Reach', 'Importance', 'Willingness To Pay']
    e.forEach(item => {
      data.push({
        'Unmet Need': item[3],
        'Reach(%) ': item[2],
        'Importance(%)': item[0],
        'Willingness To Pay(%)': item[1],
        // id: item[4]
      })
    })
    let finalData = data.sort((a, b) => b.reach - a.reach)
    dataToFile(finalData,fileName,fileType,base64)
  }

  const toFixed1 = (data) => {
    return (Math.floor(data * 100) / 100).toFixed(1)
  }

  const exportAverageData = async (data, fileName, fileType, averageBase64) => {
    const finalData = [
      { Category: 'Ratings', SubMetric: 'Reach', 'Percent(%)': toFixed1(data.pies[4])},
      { Category: 'Ratings', SubMetric: 'Importance', 'Percent(%)': toFixed1(data.pies[1])},
      { Category: 'Ratings', SubMetric: 'Willingness To Pay', 'Percent(%)': toFixed1(data.pies[0])},
    ]
    data.needState.forEach(item => {
      finalData.push({
        Category: 'Occasions',
        SubMetric: item.response,
        'Percent(%)': item.percent
      })
    })
    data.generation.forEach(item => {
      finalData.push({
        Category: 'Generation',
        SubMetric: item.response,
        'Percent(%)': item.percent
      })
    })  
    data.lifestage.forEach(item => {
      finalData.push({
        Category: 'Lifestage',
        SubMetric: item.response,
        'Percent(%)': item.percent
      }) 
    })
    data.frequencyOfConsumption.forEach(item => {
      finalData.push({
        Category: 'Frequency of Consumption',
        SubMetric: item.response,
        'Percent(%)': item.percent
      })
    })
    data.contemporaryCooks.forEach(item => {  
      finalData.push({
        Category: 'Contemporary Cooks',
        SubMetric: item.response,
        'Percent(%)': item.percent
      })
    })
    await averagedataToFile(finalData, fileName, fileType, averageBase64);
  }

  const onSaveExcel = async (e) => {
    if (e === 'top10') {
      const chartInstance = dataARef.getEchartsInstance();
      const base64 = chartInstance.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#011c03'
      });
      await exportData(dataASortLimit(dataA), 'Top10UnmetNeeds', 'excel', base64);
    } else if (e === 'fullList') {
      await exportData(dataA, 'UnmetNeedFullList', 'excel');
    } else if (e === 'average') {
      const chartContainer = document.querySelector(`.${style.chartDetailContent}`);
      try {
        const html2canvas = await import('html2canvas');
        const canvas = await html2canvas.default(chartContainer, {
          backgroundColor: '#011c03',
          scale: 2,
          useCORS: true,
          logging: false
        });
        const averageBase64 = canvas.toDataURL('image/png');
        exportAverageData(detailData, 'AverageRatings', 'excel', averageBase64);
      } catch (error) {
        console.error('Error generating chart image:', error);
        // 如果图片生成失败，仍然导出数据
        exportAverageData(detailData, 'AverageRatings', 'excel');
      }
    }
  };

  const onSaveCsv = (e) => {
    if (e === 'top10') {
      exportData(dataASortLimit(dataA),'Top10UnmetNeeds','csv');
    } else if (e === 'fullList') {
      exportData(dataA,'UnmetNeedFullList','csv');
    } else if (e === 'average') {
      exportAverageData(detailData,'AverageRatings','csv');
    };
  };

  const onSaveImg = (e) => {
    if (e === 'top10') {
      const chartInstance = dataARef.getEchartsInstance();
      
      const base64 = chartInstance.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#011c03'
      });

      const link = document.createElement('a');
      link.download = 'Top10UnmetNeeds.png';
      link.href = base64;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (e === 'average') {
      const chartContainer = document.querySelector(`.${style.chartDetailContent}`);
      import('html2canvas').then(html2canvas => {
        html2canvas.default(chartContainer, {
          backgroundColor: '#011c03',
          scale: 2,
          useCORS: true,
          logging: false
        }).then(canvas => {
          const base64 = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.download = 'AverageRatings.png';
          link.href = base64;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      });
    }
  };

  const top10DropItems = [
    {
      key: '1',
      label: <span onClick={() => onSaveExcel('top10')}>Export as Excel</span>,
    },
    {
      key: '2',
      label: <span onClick={() => onSaveCsv('top10')}>Export as Csv</span>,
    },
    {
      key: '3',
      label: <span onClick={() => onSaveImg('top10')}>Export as PNG</span>,
    },
  ];

  const fullListDropItems = [
    {
      key: '1',
      label: <span onClick={() => onSaveExcel('fullList')}>Export as Excel</span>,
    },
    {
      key: '2',
      label: <span onClick={() => onSaveCsv('fullList')}>Export as Csv</span>,
    },
  ];

  const averageDropItems = [
    {
      key: '1',
      label: <span onClick={() => onSaveExcel('average')}>Export as Excel</span>,
    },
    {
      key: '2',
      label: <span onClick={() => onSaveCsv('average')}>Export as Csv</span>,
    }, 
    {
      key: '3',
      label: <span onClick={() => onSaveImg('average')}>Export as PNG</span>,
    },
  ];

  return <div className={style.chartMain}>
    {/* <PlantHeader /> */}
    <div className={style.chartMainHeader}></div>
    {isLoading && (
      <div className={style.loadingOverlay}>
        <div className={style.spinner}></div>
        <div className={style.loadingText}>Loading...</div>
      </div>
    )}
    <div className={style.chartTop}>
      <div className={style.chartLeftTop}>
        <ChatTitle text="Top 10 Unmet Needs"/>
          <Dropdown className={style.chartDropdown} menu={{ items: top10DropItems }}>
            <MoreOutlined />
          </Dropdown>
        <InfoTooltip exclamationIcon={exclamation} />
        {
          !dataA.length ? <NoData />
            : <ReactEcharts style={{ height: '100%', width: '100%' }}
              ref={(e) => {
                dataARef = e;
              }}
              option={options.optionA(dataASortLimit(dataA))}
              onEvents={{ 'click': dataAOnClick }}
              notMerge />
        }
      </div>
      <div className={style.chartRightTop}>
        <div style={{float:'left'}}>
          <ChatTitle text="Unmet Need Full List"/>
        </div>
          <Dropdown className={style.fullListDropdown} menu={{ items: fullListDropItems }}>
            <MoreOutlined />
          </Dropdown>
        {dataA.length!=0 && <ChartListFilter />}

        {
          !dataA.length ? <NoData />
            : <>
              <div>
                <Search onSearch={handleSearch} />
              </div>
              <ReactEcharts
                style={{ height: '88%', width: '100%' }}
                ref={(e) => {
                  dataBRef = e;
                }}
                option={options.optionB(dataB)}
                onEvents={{ 'click': dataBOnClick }} />
            </>
        }
      </div>
    </div>

    <div className={style.chartBottom} ref={chartListRef}>
      <div className={style.chartLeftBottom}>
        <ChatTitle text="Consumer Verbatims" />
        <ChartList/>
      </div>
      <div className={style.chartRightBottom}>
        <ChatTitle text="Average Ratings" />
          {showAverageDropItems ? <Dropdown className={style.averageDropdown} menu={{ items: averageDropItems }}>
            <MoreOutlined />
          </Dropdown> : <Dropdown className={style.averageDropdown} menu={{items:[]}}>
            <MoreOutlined />
          </Dropdown>}
        {
          !dataD ? <NoData />
            : <ChartDetail data={dataD} />
        }
      </div>
    </div>
  </div>;
};

export default ChartMain;
